import { DialogContentText, Stack, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useState } from "react";
import http from "../../Http";
import { PROFILE_ENDPOINTS } from "../../constants/Endpoints";
import Loading from "../Loading";

/**
 * This function represents the profile popup dialog when the profile is incomplete.
 * @returns React Component
 */
export default function ProfileDialog({ open, user }) {
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState({
    firstName: user.firstName ?? "",
    lastName: user.lastName && user.lastName !== 'Onbekend' ? user.lastName : "",
  });

  const handleSubmit = async () => {
    const data = {
      first_name: profile.firstName,
      last_name: profile.lastName,
    };

    setLoading(true);

    http
      .put(PROFILE_ENDPOINTS.EMPLOYEE, data)
      .then(() => {
        window.location.reload();
      })
      .catch((_) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Dialog open={open}>
        <DialogTitle align="center">Profiel invullen</DialogTitle>
        <DialogContentText sx={{ padding: "0 24px" }}>
          Vul je profiel in om gebruik te kunnen maken van de Studyplanner
          portal.
        </DialogContentText>
        <DialogContent>
          <Stack direction="row" spacing={2}>
            <TextField
              label="Voornaam"
              variant="standard"
              value={profile.firstName}
              disabled={user.firstName != null}
              onChange={(e) => {
                setProfile({ ...profile, firstName: e.target.value });
              }}
              fullWidth
            />
          </Stack>
          <Stack direction="row" spacing={2} marginTop={2}>
            <TextField
              label="Achternaam"
              variant="standard"
              value={profile.lastName}
              onChange={(e) => {
                setProfile({ ...profile, lastName: e.target.value });
              }}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSubmit}
            color="success"
            disabled={
              loading ||
              profile.firstName.length === 0 ||
              profile.lastName.length === 0
            }
          >
            Opslaan
            {loading ? (
              <>
                <Loading size={18} />
              </>
            ) : null}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
